// Minimal JSON fetch helpers.
//
// Every endpoint here answers with JSON on both success and failure, so the
// callers below want the parsed body *and* the ok flag — a thrown error on a
// non-2xx would discard the server's message, which the auth forms display.

export async function postJson(url, body, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  let data = {};
  try {
    data = await resp.json();
  } catch {
    /* empty or non-JSON body */
  }
  return { ok: resp.ok, data };
}

export async function getJson(url, token) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const resp = await fetch(url, { headers });
  let data = {};
  try {
    data = await resp.json();
  } catch {
    /* empty or non-JSON body */
  }
  return { ok: resp.ok, data };
}
